export const GET_METRICS_REQUEST = 'GET_METRICS_REQUEST';

export function getMetrics() {
  return {
    type: GET_METRICS_REQUEST,
  };
}
